<template>
  <div class="home">home
  </div>
</template>

<script>
import Vue from 'vue'

export default class Home extends Vue {
}
</script>
